import styled from 'styled-components'
import { colors } from '../../styles'

export const ThumbnailPreview = styled.img`
  border: 1px solid ${colors.grey10};
  max-height: 200px;
` as React.ComponentType<any>
